import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../../shared/components/loader';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
 import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../shared/components/pagination'
import moment from 'moment';
import Util from './../../../../../shared/util/util'
import CargoAllocationService from './../../../../../cargoallocation/services/cargoallocation.service'
import TripServices from './../../../../services/firstAndLastmilemanagement.service'
export default {
  name: 'UADCutoffs',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Pagination
  },
  data() {
    return {
      tableColumn: ['Modification Date', 'Facility Type', 'Facility Name','RAD Cut-off','UAD Cut-off','User name'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:10,
    }
  },
  computed: {},
   mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.localuserid = userdetail.userid;
    this.hubid = userdetail.hubID[0];
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.isLoading = true;
   this.GetUADLogs()

  },
  methods: {
    onPageChange(page) {
     this.currentPage = page;
     this.offset = (page - 1) * this.pageLimit
     this.GetUADLogs();
   },
    async GetUADLogs() {
      try {
        this.isLoading = true;
        this.tableItems = [];
        this.totalCount = 0;
        this.defaultcount = [];
        let inputPayload = {
          defaulthubid: this.hubid,
          userid : this.localuserid,
          offset :this.offset,
          limit : this.pageLimit,
        };
        let result = await TripServices.GetUADLogs(inputPayload);
        if (result.data.code == 200) {
          this.totalCount = Number(result.data.data.count);
          if (this.totalCount > 0) {
            this.tableItems = result.data.data.rows.map((el,index) => {
              return {
                "id":index+1,
                "Modification Date":  moment.utc(el.lastmodifieddate).format("DD-MM-YYYY HH:mm:ss").valueOf(),
                "Facility Type":'SVC',
                "Facility Name":el.hubname,
                "RAD Cut-off":el.radinscandate,
                "UAD Cut-off":el.uadcutoff,
                "User name":el.lastmodifiedby,
              };
            });
          } else {
            this.tableItems = [];
          }
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1;
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        // await this.GetUADLogs();
        this.isLoading = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/UADConfiguration/uadcutofflogs/uadcutofflogs.js